var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2B2B2B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.76 1.947A1.947 1.947 0 0 0 33.812 0C15.148.021.022 15.147 0 33.812a1.947 1.947 0 1 0 3.895 0C3.914 17.296 17.297 3.913 33.812 3.895a1.947 1.947 0 0 0 1.948-1.948z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.506 35.761a1.947 1.947 0 0 0 1.948-1.947c.013-11.239 9.12-20.347 20.358-20.36a1.947 1.947 0 0 0 0-3.894C20.424 9.575 9.574 20.425 9.56 33.814c0 1.076.872 1.947 1.947 1.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.065 35.761a1.947 1.947 0 0 0 1.948-1.947c.006-5.962 4.838-10.794 10.8-10.8a1.947 1.947 0 0 0 0-3.895c-8.112.009-14.686 6.583-14.695 14.695 0 1.076.872 1.947 1.947 1.947zM33.812 37a3.188 3.188 0 1 0 0-6.375 3.188 3.188 0 0 0 0 6.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.fdef52b13750e03f2916eb853b56e428.svg";
export { ForwardRef as ReactComponent };